import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { filter, map, switchMap, take } from "rxjs/operators";
import { AuthService } from "src/app/services/auth/auth.service";

@Injectable()
export class AzureTokenInterceptor implements HttpInterceptor {
  private readonly authService: AuthService = inject(AuthService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.token.pipe(
      filter((token: string | undefined): token is string => !!token),
      take(1),
      map((token: string) => ({
        token,
        appendToken: this.authService.resourceNeedsToken(req.url)
      })),
      switchMap(({ token, appendToken }) => {
        const clonedReq =
          token && appendToken
            ? req.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`
                }
              })
            : req;

        return next.handle(clonedReq);
      })
    );
  }

/*   intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const request = this.tokenRequest();
    const tokenDetails: TokenDetails | undefined = this.authService.token.getValue();

    return of(tokenDetails).pipe(
      map((accountDetails: TokenDetails | undefined) => ({
        isValidToken: this.isValidToken((accountDetails?.idTokenClaims as TokenDetailsAccountClaims)?.exp),
        idToken: accountDetails?.idToken || '',
        appendToken: this.resourceNeedsToken(req.url),
      })),
      switchMap(({ isValidToken, idToken, appendToken }) => {
        if ((!isValidToken && appendToken) || (appendToken && !idToken)) {
          return this.authService.acquireTokenSilent(request).pipe(
            tap((response) => this.authService.token.next(response as unknown as TokenDetails)),
            map(({ idToken }) => ({ idToken, appendToken }))
          );
        } else {
          return of({ idToken, appendToken });
        }
      }),
      switchMap(({ idToken, appendToken }) => {
        const clonedReq = this.cloneRequest(req, idToken, appendToken);
        return next.handle(clonedReq);
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === HttpStatusCode.Unauthorized || err instanceof InteractionRequiredAuthError) {
          this.authService.acquireTokenRedirect(request);
        }
        return throwError(err);
      })
    );
  }

  private isValidToken(expiration: number | undefined): boolean {
    return new Date(new Date().getTime() - 1000 * 300).valueOf() < (expiration || 1) * 1000;
  }

  private resourceNeedsToken(request_url: string): boolean {
    return environment.bypass_auth_token_resources.every((resource) => !request_url.startsWith(resource) && !request_url.includes('/assets/i18n/'));
  }

  private tokenRequest(): SilentRequest | RedirectRequest {
    const account = this.authService.getActiveAccount() ?? undefined;

    return {
      account,
      scopes: [],
    };
  }

  private cloneRequest(req: HttpRequest<unknown>, idToken: string, append_token: boolean): HttpRequest<unknown> {
    if (append_token) {
      const clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${idToken}`,
        },
      });

      return clonedReq;
    } else {
      return req;
    }
  } */
}
